import { render, staticRenderFns } from "./ZuordnungenMenu.vue?vue&type=template&id=fc1eff5a"
import script from "./ZuordnungenMenu.vue?vue&type=script&lang=ts"
export * from "./ZuordnungenMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports